import { twMerge } from 'tailwind-merge'

interface ServicesBannerProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string
  description: string
  imageSrc: string
  imageClassName?: string
}

export function ServicesBanner({
  title,
  description,
  imageSrc,
  className,
}: ServicesBannerProps) {
  return (
    <section
      style={{ backgroundImage: `url(${imageSrc})` }}
      className={twMerge('h-128 bg-contain', className)}
    >
      <div className="banner-gradient flex size-full flex-col justify-center gap-4 text-center md:px-20 md:text-start">
        <h1 className="text-3xl font-light uppercase tracking-[0.425rem] text-white md:text-4xl xl:text-5xl 2xl:text-6xl">
          {title}
        </h1>
        <h2 className="text-shadow-lg max-w-3xl text-lg tracking-[0.250rem] text-white lg:text-xl lg:tracking-[0.450rem] 2xl:text-2xl 2xl:tracking-[0.650rem]">
          {description}
        </h2>
      </div>
    </section>
  )
}
